var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('v-btn',{on:{"click":_vm.OpenRatingModel}},[_vm._v("Add Course Rating")]),_c('app-review-list'),_c('app-review',{attrs:{"dialog":_vm.Dialog},on:{"close":_vm.CloseRatingModel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }